/* global femcare */

femcare.product.viewer360 = {

    init: function () {
        var $mediaPanel = $('.product-main__media-panel');
        this.configPath = $mediaPanel.data('360-src') || null;
        this.licensePath = $mediaPanel.data('360-lic') || null;

        if (this.configPath && this.licensePath) {
            this.loadWebrotate();
        }
    },

    loadWebrotate: function () {
        var assetsPath = femcare.shared.util.getAssetsPath();
        var jsPath = assetsPath + '/js/vendor/webrotate/imagerotator.js';
        var cssPath = assetsPath + '/css/webrotate.css';

        try {
            femcare.shared.ui.setLoadingOverlay(true);

            $('head').append('<link rel="stylesheet" href="' + cssPath + '"></link>');
            $('head').append('<script src="' + jsPath + '"></script>');

            $('#product-360-player').rotator({
                licenseFileURL: this.licensePath,
                configFileURL: this.configPath,
                googleEventTracking: false,
                apiReadyCallback: function () {
                    console.log('360 API ready');
                }
            });

            femcare.shared.ui.setLoadingOverlay(false);

        } catch (error) {
            femcare.shared.ui.setLoadingOverlay(false);
        }
    }
};